<template>
   <div class="listing d-flex flex-column vh-100">
      <!-- navbar -->
      <div class="listing-navbar bg-primary d-flex align-items-center gap-3 shadow-sm mb-auto p-3">
         <a  @click="goBack()"><i class="bi bi-arrow-left text-white fs-5"></i></a>
         <a   >
            <div class="d-flex align-items-center gap-2">
               <span class="bg-white rounded p-1">
               <img :src="$asset_path+current_cat.img" alt="" class="img-fluid">
               </span>
               <div>
                  <h6 class="fw-bold text-white mb-0">{{current_cat?current_cat.name:'Hot Deals'}}</h6>
                  <p class="text-white-50 small m-0">{{data?data.length:0}} Items</p>
               </div>
            </div>
         </a>
         <!--<div class="d-flex align-items-center gap-2 ms-auto">-->
         <!--   <a href="#" class="link-dark bg-light rounded-circle user-icon" data-bs-toggle="offcanvas" data-bs-target="#searchoffcanvas"-->
         <!--      aria-controls="searchoffcanvas"><i-->
         <!--      class="icofont-search-1 fs-6"></i></a>-->
         <!--   <a class="toggle" href="#">-->
         <!--   <b class="link-dark bg-light rounded-circle user-icon">-->
         <!--   <i class="bi bi-list d-flex m-0 h4"></i>-->
         <!--   </b>-->
         <!--   </a>-->
         <!--</div>-->
      </div>
      <!-- body -->
      <div class="vh-100 my-auto overflow-auto p-1">
         <div class=" ">
            
            <div class=" ">
               <div class="bg-white rounded shadow-sm">
                  <div class="tab-content" id="v-pills-tabContent">
                     <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab" tabindex="0">
                        <!--<div class="border-bottom p-2">-->
                        <!--   <div class="rounded-3 ps-3 shadow-sm d-flex gap-1 align-items-center bg-success bg-gradient justify-content-between">-->
                        <!--      <div class="py-3">-->
                        <!--         <small class="text-white-50 d-flex align-items-center"><i class="bi bi-basket me-1 d-flex"></i> UPTO</small>-->
                        <!--         <h3 class="fw-bold text-warning mb-0">20% OFF</h3>-->
                        <!--         <p class="text-white mb-2">Fruits & Vegetables</p>-->
                        <!--         <a href="listing.html" class="btn btn-light text-success fw-bold rounded-3 shadow-sm btn-sm border-0">SHOP NOW</a>-->
                        <!--      </div>-->
                        <!--      <img src="img/banner2.png" alt="" class="img-fluid mt-auto osahan-offer-banner-2">-->
                        <!--   </div>-->
                        <!--   <p class="text-muted pt-2 mb-0"><span class="fw-bold text-dark">42 items</span> in Hot Deals-->
                        <!--   </p>-->
                        <!--</div>-->

                    <!-- event -->
                     
                        <div class="row g-0" v-if="current_cat.name=='Event'">

                           <div class="d-flex gap-2 justify-content-start overflow-auto category-scroll">
                              <div class="m-2" v-for="(categorylistings, i) in eventcatdata" :key="i">
                                  <button class="btn btn-primary" @click="filterevent(categorylistings.cat_id)">
                                      {{ categorylistings.name }}
                                  </button>
                              </div>
                          </div> 

                           <div class="col-6 border-end" v-for="(event, i) in data" :key="i">
                               <router-link :to="`/singleeventlist?id=${event.id}&name=event`" >
                              <div class="card bg-transparent border-0 p-2 h-100">
                               
                                   <div class="bg-light rounded-2 product-box" :style="'background:url('+$asset_path+'event/'+event.img+') top center / cover no-repeat'"></div>
                                
                                 <div class="card-body p-0 mb-1">
                                    <small class="text-muted">{{ event.cat_name }}</small><br>
                                    <p class=" fw-bold text-dark">{{ event.name }}</p>
                                    <p class="  mb-0 text-dark">
                                       {{ event.description.split(' ').slice(0, 10).join(' ') }}...
                                     </p>                                     
                                 </div>
                                 <div
                                    class="card-footer bg-transparent border-0 d-flex align-items-end justify-content-between p-0">
                                    <div>
                                       <p class="text-muted "><i class="bi bi-clock-history"></i> {{ event.time?''+event.time:'' }}</p>
                                       <del class="text-muted small">₹ {{ event.cost }}</del>
                                       <p class="fw-bold m-0">₹ {{ event.cost }}</p>
                                       <p class="text-muted mb-1"><i class="bi bi-geo-alt-fill"></i> {{ event.location }}</p>
                                    </div>
                                    <!--<a -->
                                    <!--   class="btn btn-outline-success btn-sm border-dark-subtle fw-bold rounded-3 shadow-sm px-3">View</a >-->
                                 </div>
                             
                              </div>
                           </router-link>
                           </div>
                           </div>

                           <!--  event-->



                          <!-- business -->

                          <div class="row g-0" v-if="current_cat.name=='Business'">
                           <div class="d-flex gap-2 justify-content-start overflow-auto category-scroll">
                              <div class="m-2" v-for="(categorylistings, i) in categorydata" :key="i">
                                  <button class="btn btn-primary" @click="filterbusiness(categorylistings.cat_id)">
                                      {{ categorylistings.name }}
                                  </button>
                              </div>
                          </div>                                                  
                           <div class="col-6 border-end" v-for="(listings, i) in data" :key="i">
                              <router-link :to="`/singleeventlist?id=${listings.id}&name=business`" >
                              <div class="card bg-transparent border-0 p-2 h-100">
                              
                                      <div class="bg-light rounded-2 product-box" :style="'background:url('+$asset_path+'business/'+listings.img+') top center / cover no-repeat'"></div>
                                    <!--<img :src="$asset_path+'business/'+listings.img"  alt="" class="img-fluid w-75 d-block mx-auto">-->
                                
                                 <div class="card-body p-0 mb-3">
                                    <small class="text-muted">{{ listings.name }}</small>
                                    <p class="card-title fw-bold mb-0">{{ listings.catname }}</p>
                                 </div>
                                 <div
                                    class="card-footer bg-transparent border-0 d-flex align-items-end justify-content-between p-0">
                                    <div>
                                       <p class="text-muted mb-1">{{ listings.description.substring(0, 50) }}...</p>                                      
                                    </div>
                                   <a 
                                       class="btn btn-outline-success btn-sm border-dark-subtle fw-bold rounded-3 shadow-sm px-3">View</a >
                                 </div>
                              </div>
                           </router-link >
                           </div>
                           </div>

                           <!-- business -->

             
                            <!-- property -->

                     
                        <div class="row g-0" v-if="current_cat.name=='Property'">
                           <div class="col-6 border-end" v-for="(properties, i) in data" :key="i">
                              <router-link :to="`/singleeventlist?id=${properties.id}&name=property`" >
                              <div class="card bg-transparent border-0 p-2 h-100">
                                 
                                      <div class="bg-light rounded-2 product-box" :style="'background:url('+$asset_path+'property/'+properties.img+') top center / cover no-repeat'"></div>
                                    <!--<img :src="$asset_path+'properties/'+properties.img"  alt="" class="img-fluid w-75 d-block mx-auto">-->
                                
                                 <div class="card-body p-0 mb-3">
                                    <small class="text-muted">{{ properties.name }}</small>
                                    <p class="card-title fw-bold mb-0">{{ properties.description.substring(0, 50) }}...</p>

                                 </div>
                                 <div
                                    class="card-footer bg-transparent border-0 d-flex align-items-end justify-content-between p-0">
                                    <div>
                                       <p class="text-muted mb-1">{{ properties.feet?properties.feet+' sq/feet':'' }} </p>
                                       <del class="text-muted small">₹{{ properties.cost }}</del>
                                       <p class="fw-bold m-0">₹{{ properties.cost }}</p>
                                       <!-- <p class="text-muted mb-1"><i class="bi bi-telephone"></i>{{ properties.contact }}</p> -->
                                    </div>
                                   <router-link :to="`/singleeventlist?id=${properties.id}&name=property`" 
                                       class="btn btn-outline-success btn-sm border-dark-subtle fw-bold rounded-3 shadow-sm px-3">View</router-link >
                                 </div>
                              </div>
                           </router-link >
                           </div>
                           </div>

                             <!-- food --> 
  
                        <div class="row g-0" v-if="current_cat.name=='Food'">
                           <div class="d-flex gap-2 justify-content-start overflow-auto category-scroll">
                              <div v-for="(foodcategory, i) in foodcategorylist" :key="i">
                                <button class="btn btn-primary" @click="filterfood(foodcategory.cat_id)">
                                  {{ foodcategory.name }}
                                </button>
                              </div>
                            </div>
                            
                           <div class="col-6 border-end" v-for="(food, i) in data" :key="i">
                              <router-link :to="`/singleeventlist?id=${food.id}&name=food`" >
                              <div class="card bg-transparent border-0 p-2 h-100">
                             
                                      <div class="bg-light rounded-2 product-box" :style="'background:url('+$asset_path+'food/'+food.img+') top center / cover no-repeat'"></div>
                                    <!--<img :src="$asset_path+'food/'+food.img"  alt="" class="img-fluid w-75 d-block mx-auto">-->
                                 
                                 <div class="card-body p-0 mb-3">
                                    <small class="text-primary" v-if="food?.catname">{{ food.catname }}</small><br>
                                    <text class="text-dark fw-bold ">{{ food.name }}</text>
                                    <p class="card-title mb-0" v-if="food?.description">{{ food.description.substring(0, 50) }}...</p>
                                 </div>
                                 <div
                                    class="card-footer bg-transparent border-0 d-flex align-items-end justify-content-between p-0">
                                    <div>
                                       <p v-if="food.location" class="text-muted mb-1 twoline"><i class="bi bi-geo-alt-fill"></i> {{ food.location }}</p>
                                    </div>
                                    <router-link :to="`/singleeventlist?id=${food.id}&name=food`" 
                                       class="btn btn-outline-success btn-sm border-dark-subtle fw-bold rounded-3 shadow-sm px-3">View</router-link >
                                 </div>
                              </div>
                           </router-link >
                           </div>
                           </div>


                        <div class="row g-0" v-if="current_cat.name=='News'">
                           <div class="col-6 border-end" v-for="(news, i) in data" :key="i">
                              <div class="card bg-transparent border-0 p-2 h-100">

                                 <a :href="news.link" target="_blank">
                                    <!-- <router-link :to="`/singleeventlist?id=${data_row.id}&name=news`" class="link-dark">-->
                                       <div class="bg-light rounded-2 product-box" :style="'background:url('+news.img+') top center / cover no-repeat'"> 
                                          <!--<img :src="$asset_path+'event/'+event.img"  alt="" class="img-fluid w-75 d-block mx-auto">-->
                                       </div>
                                    <!-- </router-link> -->
                                    <!-- <div class="bg-info position-absolute top-0 text-white osahan-badge text-center mx-3">
                                       <b>{{data_row.name}}</b><br>
                                    </div>
                                    <div class="card-body p-0">
                                       <small class="text-muted">{{data_row.name}}</small>
                                       <h6 class="card-title fw-bold">{{data_row.location}}</h6>                         
                                        <p class="card-text text-muted">100 g x 2</p> -->
                                    <!-- </div> -->
                                    
                                    <div v-if="news?.category" class="bg-info position-absolute top-0 text-white osahan-badge text-center mx-3">
                                       <b>{{news.category}}</b> 
                                    </div>
                                    <div class="card-body p-0">
                                       <h6>{{news.name}}</h6>
                                       <p class="card-text text-dark">{{news?.actualDate}}</p> 
                                       <small class="text-muted">{{ news.description.substring(0, 150) }}...</small>
                                       <!-- <h6 class="card-title fw-bold">{{data_row.location}}</h6>                          -->
                                        
                                    </div>
                                 </a>


                                 <!-- <router-link :to="`/singleeventlist?id=${news.id}&name=News`" >
                                      <div class="bg-light rounded-2 product-box" :style="'background:url('+$asset_path+'news/'+news.img+') top center / cover no-repeat'"></div>
                                    <img :src="$asset_path+'news/'+news.img"  alt="" class="img-fluid w-75 d-block mx-auto">
                                 </router-link >
                                 <div class="card-body p-0 mb-3">
                                    <small class="text-muted">{{ news.name }}</small>
                                    <p class="card-title fw-bold mb-0">{{ news.description }}</p>
                                 </div>
                                 <div
                                    class="card-footer bg-transparent border-0 d-flex align-items-end justify-content-between p-0">
                                    <div>-->
                                    <!--   <p class="text-muted mb-1">{{ news.feet }} sq/feet</p>-->
                                    <!--   <del class="text-muted small">₹{{ news.cost }}</del>-->
                                    <!--   <p class="fw-bold m-0">₹{{ news.cost }}</p>-->
                                    <!--   <p class="text-muted mb-1"><i class="bi bi-telephone"></i>{{ news.contact }}</p>-->
                                    <!--</div>-->
                                     <!--<router-link :to="`/singleeventlist?id=${news.id}&name=News`" -->
                                     <!--  class="btn btn-outline-success btn-sm border-dark-subtle fw-bold rounded-3 shadow-sm px-3">View</router-link > -->
                                 <!-- </div> -->
                              </div>
                           </div>
                           </div>



                           <div class="row g-0" v-if="current_cat.name=='job'">
                              <div class="col-6 border-end" v-for="(job, i) in data" :key="i">
                                 <router-link :to="`/singleeventlist?id=${job.id}&name=job`" >
                                 <div class="card bg-transparent border-0 p-2 h-100">
                                  
                                         <div class="bg-light rounded-2 product-box" :style="'background:url('+$asset_path+'jobs/'+job.img+') top center / cover no-repeat'"></div>
                                       <!--<img :src="$asset_path+'news/'+news.img"  alt="" class="img-fluid w-75 d-block mx-auto">-->
                                   
                                    <div class="card-body p-0 mb-1">
                                       <small class="text-muted">{{ job.jobtype }}</small>
                                       <p class="card-title fw-bold mb-0 text-dark"> {{ job.title }}</p>
                                       <p class="text-muted"><i class="bi bi-building-check"></i> {{ job.companyname }}</p>
                                       <p v-if="job.jobexperience" class="card-title fw-bold mb-0">{{ job.jobexperience }}</p>
                                       <p v-if="job.experienceyear" class="text-muted">{{ job.experienceyear }}</p>
                                    </div>
                                    <div
                                       class="card-footer bg-transparent border-0 d-flex align-items-end justify-content-between p-0">
                                       <!--<div>-->
                                       <!--   <p class="text-muted mb-1">{{ news.feet }} sq/feet</p>-->
                                       <!--   <del class="text-muted small">₹{{ news.cost }}</del>-->
                                       <!--   <p class="fw-bold m-0">₹{{ news.cost }}</p>-->
                                       <!--   <p class="text-muted mb-1"><i class="bi bi-telephone"></i>{{ news.contact }}</p>-->
                                       <!--</div>-->
                                       <router-link :to="`/singleeventlist?id=${job.id}&name=job`" 
                                          class="btn btn-outline-success btn-sm border-dark-subtle fw-bold rounded-3 shadow-sm px-3">View</router-link >
                                    </div>
                                 </div>
                              </router-link >
                              </div>
                              </div>




                          
                        </div> 
                     
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div> 
</template>
<style>
.weather-container {
  text-align: center;
    font-family: Arial, sans-serif;
    padding: 4px 20px;
    background: #f4f4f4;
    margin: auto;
    border-radius: 10px;
}
.bg_card{
  background: #ededec;
    margin: 10px 0px;
    padding-bottom: 10px;
}
.category-scroll {
  white-space: nowrap;
  overflow-x: auto;
  flex-wrap: nowrap;
  padding-bottom: 10px; /* Optional: for better scrolling UX */
}
</style>

<script> 
import axios from "@/plugins/axios";  
import { useRoute } from 'vue-router'; 

export default {
  name: 'HomeView',
  components: { 
  },
  mounted() {
      const route = useRoute();
      this.currentUrl = window.location.origin + encodeURIComponent(route.fullPath);
    // this.initializeHomeContent();
      var $main_nav = $('#main-nav');
    var $toggle = $('.toggle');
    var defaultOptions = {
        disableAt: false,
        customToggle: $toggle,
        levelSpacing: 40,
        navTitle: 'App',
        levelTitles: true,
        levelTitleAsBack: true,
        pushContent: '#container',
        insertClose: 2
    };
    var Nav = $main_nav.hcOffcanvasNav(defaultOptions);
    
    this.fetchWeather();

         if (this.$route.query.name) {
         this.getHomeBasic(this.$route.query.name);
         }

         else{
         this.getHomeBasic();
         } // Call the method here
},
  data() {
    return {
      loading:false,
      error:null,
      data:[],
      categorydata:[],
      foodcategorylist:[],
      eventcatdata:[],
      current_cat:[], 
      
        current_temperature:0,
        currentUrl:''
     


    }
  },
  methods:{
       goBack() {
      if (this.$route.query.from) {
        this.$router.push(this.$route.query.from);
      } else {
        this.$router.go(-1);
      }
    },
    initializeHomeContent(){
    

    // Coupons
    $('.coupons').slick({
        infinite: false,
        arrows: false,
        autoplay: true,
        slidesToShow: 1.3,
        slidesToScroll: 1,
    });

    // Top Picks - Homepage
    $('.top-picks').slick({
        infinite: false,
        arrows: false,
        autoplay: true,
        slidesToShow: 2.3,
        slidesToScroll: 1,
    });

    // All Categories - Homepage
    $('.all-cate').slick({
        infinite: false,
        arrows: false,
        autoplay: true,
        slidesToShow: 4.5,
        slidesToScroll: 3,
    });

    // Product Detail
    $('.product-slider').slick({
        arrows: false,
        autoplay: true,
        infinite: false,
        dots: true,
    });
    // this.getHomeBasic();
    }
,
async fetchWeather() {
      const url =
        "https://api.open-meteo.com/v1/forecast?latitude=17.6599&longitude=75.9064&hourly=apparent_temperature&timezone=auto&forecast_days=1";

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error("Weather data not available");
        const data = await response.json();
        
        // Get the latest hourly temperature
        if (data.hourly && data.hourly.apparent_temperature.length > 0) {
          this.current_temperature = data.hourly.apparent_temperature[0]; // First hour's temperature
        }
      } catch (error) {
        console.error("Error fetching weather:", error);
      }
    }, 
    async getHomeBasic(name="") {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("getview",{_name:name}).then((response) => {
            self.data = response.data.data;
            self.current_cat = response.data.current_cat;
            self.categorydata = response.data.categorydata;
            self.foodcategorylist = response.data.foodcategorylist;
            self.eventcatdata = response.data.eventcatdata;
            // document.title =response.data.title;
            self.updateMetaTags(response.data.datarow);
            
        
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 

     updateMetaTags(datarow) {
          document.title = datarow.title;// || "MH13 City Directory";
          
          const shortDesc = datarow.description.length > 160 ? datarow.description.slice(0, 157) + "..." : datarow.description;
          
          this.setMetaTag("property", "og:title", datarow.name);
          this.setMetaTag("property", "og:description", shortDesc);
          this.setMetaTag("property", "og:image", `${this.$asset_path}${datarow.img}`);
          this.setMetaTag("property", "og:url", this.currentUrl);
          this.setMetaTag("property", "og:type", "website");
          this.setMetaTag("name", "twitter:card", "summary_large_image");
          this.setMetaTag("name", "twitter:title", datarow.name);
          this.setMetaTag("name", "twitter:description", shortDesc);
          this.setMetaTag("name", "twitter:image", `${this.$asset_path}${datarow.img}`);
        },
    
        setMetaTag(attr, name, content) {
          let tag = document.querySelector(`meta[${attr}='${name}']`);
          if (!tag) {
            tag = document.createElement("meta");
            tag.setAttribute(attr, name);
            document.head.appendChild(tag);
          }
          tag.setAttribute("content", content || "");
        },

      async filterbusiness(cat_id="") {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("filterbusinesscat",{_cat_id:cat_id}).then((response) => {
            self.data = response.data.data;
            self.current_cat = response.data.current_cat;
            
            
        
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 

      async filterfood(cat_id="") {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("filterfoodcat",{_cat_id:cat_id}).then((response) => {
            self.data = response.data.data;
            self.current_cat = response.data.current_cat;
            
            
        
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 

      async filterevent(cat_id="") {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("filtereventcat",{_cat_id:cat_id}).then((response) => {
            self.data = response.data.data;
            self.current_cat = response.data.current_cat;
            
            
        
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 















  }
}
</script>
